export const data = {
    en: [
          {
            value: false,
            sponsor: 'Institute for Occupational Science of Metal Technology, Leibniz Universität Hannover',
            src:  require('@/assets/sponsor1.png'),
          },
          {
            value: false,
            sponsor: 'Adolf Kolping School Lohne',
            src:  require('@/assets/sponsor2.png'),
          },
          {
            value: false,
            sponsor: 'Heinrich Büssing School - Vocational Schools Technik Braunschweig',
            src:  require('@/assets/sponsor3.png'),
          },
          {
            value: false,
            sponsor: 'Promotion and Education Center of the Handwerkskammer Hannover',
            src:  require('@/assets/sponsor4.png'),
          },
          {
            value: false,
            sponsor: 'Landesinnungsverband Niedersachsen of the automotive technician trade',
            src:  require('@/assets/sponsor5.jpg'),
          },
          {
            value: false,
            sponsor: '',
            src: '',
          },
    ],
    de: [
          {
            value: false,
            sponsor: 'Institut für Berufswissenschaften der Metalltechnik, Leibniz Universität Hannover ',
            src:  require('@/assets/sponsor1.png'),
          },
          {
            value: false,
            sponsor: 'Adolf-Kolping-Schule Lohne',
            src:  require('@/assets/sponsor2.png'),
          },
          {
            value: false,
            sponsor: 'Heinrich-Büssing-Schule - Berufsbildende Schulen Technik Braunschweig',
            src:  require('@/assets/sponsor3.png'),
          },
          {
            value: false,
            sponsor: 'Förderungs- und Bildungszentrum der Handwerkskammer Hannover',
            src:  require('@/assets/sponsor4.png'),
          },
          {
            value: false,
            sponsor: 'Landesinnungsverband Niedersachsen des Kfz-Technikerhandwerks',
            src:  require('@/assets/sponsor5.jpg'),
          },
          {
            value: false,
            sponsor: '',
            src: '',
          },
    ],
};